import { notification } from 'antd'
import { ReactNode, useEffect } from 'react'

const useSuccessModal = (
    state: { isSuccess?: boolean; [key: string]: any },
    message: ReactNode
) => {
    useEffect(() => {
        if (state.isSuccess) notification.success({ message })
    }, [state.isSuccess, message])
}

export default useSuccessModal
